import React from 'react';
import PropTypes from 'prop-types';

import FormError from "src/core/gd-form/common/form-error/form-error";
import DatePicker from "core/gd-form/form-element/datepicker/datepicker-new";

export default function FormDeadlineSelector(props) {
    return (
        <div className="row">
            <div className="label">Deadline</div>
            <div className="element">
                <DatePicker form={props.form}
                            name="deadline"
                            placeholderText="Select date"
                            inline={true}/>

                <FormError form={props.form} name="deadline" />
            </div>
        </div>
    )
}

FormDeadlineSelector.propTypes = {
    form: PropTypes.object
}